import { lightColorPalette } from '@linearb/linui-common';
import styled from 'styled-components';

export const StyledPerformanceSidebar = styled.aside`
  background-color: ${lightColorPalette.lbWhite};
  border-right: 1px solid ${lightColorPalette.lbBlue_10};

  display: flex;
  flex-direction: column;

  position: sticky;
  top: 0;
  height: 100vh;
  overflow: hidden;
`;

export const SectionFavoriteDashboardsContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 20vh;
  overflow-y: auto;
`;

export const StyledScrollableSection = styled.div`
  overflow-y: auto;
`;
